import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { Observable } from 'rxjs';

const loadingStore = createStore(
  { name: 'loading' },
  withProps<any>({}),
);

@Injectable({ providedIn: 'root' })
export class LoadingStore {
  select(key: string): Observable<boolean> {
    return loadingStore.pipe(select((loading) => loading[key]));
  }

  update(key: string, value: boolean): void {
    loadingStore.update((state) => ({ ...state, [key]: value}));
  }
}
